import { Card } from '@/components/ui/Card';
import { Clock, CheckCircle2, User } from 'lucide-react';
import type { WeeklyWorkItem } from '@/types';
import { formatDateShort } from '@/lib/utils';

interface WeeklyWorkSummaryProps {
  weeklyWork: WeeklyWorkItem[];
}

export function WeeklyWorkSummary({ weeklyWork }: WeeklyWorkSummaryProps) {
  const startOfWeek = new Date();
  startOfWeek.setDate(startOfWeek.getDate() - startOfWeek.getDay() + 1);

  return (
    <Card 
      title="What OrbitCrew is Working On This Week" 
      subtitle="Your execution partner - here is what we are focused on for you"
    >
      <div className="space-y-3">
        {weeklyWork.map((day, index) => {
          const date = new Date(startOfWeek);
          date.setDate(startOfWeek.getDate() + index);

          return (
          <div 
            key={day.day}
            className={`p-4 rounded-lg border ${
              index === 0 
                ? 'bg-blue-50 border-blue-200' 
                : 'bg-slate-50 border-slate-100'
            }`}
          >
            <div className="flex items-start gap-4">
              <div className={`w-16 text-center flex-shrink-0 ${
                index === 0 ? 'text-blue-600' : 'text-slate-500'
              }`}>
                <p className="text-xs font-medium uppercase">{day.day.slice(0, 3)}</p>
                <p className={`text-lg font-bold ${index === 0 ? 'text-blue-600' : 'text-slate-700'}`}>
                  {formatDateShort(date)}
                </p>
              </div>

              <div className="flex-1">
                <div className="flex items-center gap-2 mb-2">
                  <User className="w-4 h-4 text-slate-400" />
                  <span className="text-sm font-medium text-slate-700">{day.developer}</span>
                  {index === 0 && (
                    <span className="px-2 py-0.5 bg-blue-100 text-blue-700 text-xs font-medium rounded-full">
                      Today
                    </span>
                  )}
                </div>
                <ul className="space-y-1">
                  {day.tasks.map((task, taskIndex) => (
                    <li key={taskIndex} className="flex items-center gap-2 text-sm text-slate-600">
                      <CheckCircle2 className={`w-4 h-4 flex-shrink-0 ${
                        index === 0 ? 'text-blue-500' : 'text-slate-300'
                      }`} />
                      {task}
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          </div>
        )})}
      </div>

      <div className="mt-4 p-4 bg-gradient-to-r from-blue-50 to-purple-50 rounded-lg border border-blue-100">
        <div className="flex items-center gap-3">
          <Clock className="w-5 h-5 text-blue-600" />
          <p className="text-sm text-slate-700">
            <span className="font-semibold">Team availability:</span> Our developers are online and available for urgent requests during your business hours (9 AM - 6 PM EST).
          </p>
        </div>
      </div>
    </Card>
  );
}
